import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_STORAGE_KEY || 'rexpt_secret_2025';

export const secureStorage = {
  set: (key, value) => {
    try {
      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
      sessionStorage.setItem(key, encrypted);
    } catch (e) {
      console.error('Encrypt failed:', key);
    }
  },

  get: (key, defaultValue = null) => {
    try {
      const encrypted = sessionStorage.getItem(key);
      if (!encrypted) return defaultValue;
      const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      return defaultValue;
    }
  },

   remove: (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      console.error('Remove failed:', key, e);
    }
  },

  /**
   * Clear all sessionStorage
   */
  clear: () => {
    try {
      sessionStorage.clear();
    } catch (e) {
      console.error('Clear failed:', e);
    }
  },

  /**
   * Check if key exists in sessionStorage
   * @param {string} key - Storage key
   * @returns {boolean}
   */
  has: (key) => {
    try {
      return sessionStorage.getItem(key) !== null;
    } catch (e) {
      return false;
    }
  },

  /**
   * Get all keys in sessionStorage
   * @returns {string[]}
   */
  keys: () => {
    try {
      return Object.keys(sessionStorage);
    } catch (e) {
      return [];
    }
  }
};